
import React from 'react'
import { Link } from 'react-router-dom'
import {Globe, MapPin, ArrowRight} from 'lucide-react'

const Countries = () => {
  const regions = [
    {
      title: "South Asia",
      countries: "Pakistan • India • Nepal • Sri Lanka • Bangladesh",
      href: "/south-asia"
    },
    {
      title: "Southeast Asia",
      countries: "Philippines • Indonesia • Malaysia • Thailand • Vietnam",
      href: "/countries/southeast-asia"
    },
    {
      title: "GCC",
      countries: "Saudi Arabia • UAE • Qatar • Kuwait • Oman • Bahrain",
      href: "/countries/gcc"
    },
    {
      title: "Africa",
      countries: "Kenya • Nigeria • Ghana • Ethiopia • South Africa",
      href: "/countries/africa"
    },
    {
      title: "United States",
      countries: "Already in the U.S.? Endorsement & placements",
      href: "/countries/united-states"
    },
    {
      title: "UK & Europe",
      countries: "NMC (CBT/OSCE) pathways • EU opportunities",
      href: "/uk-europe"
    }
  ]

  return (
    <main className="flex-grow">
        {/* Hero Section */}
        <div className="bg-gradient-to-br from-primary-light to-white py-20 px-4">
          <div className="max-w-7xl mx-auto text-center">
            <div className="flex justify-center mb-6">
              <Globe className="h-16 w-16 text-primary-teal" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-primary-navy mb-6">
              Choose Your Destination
            </h1>
            <p className="text-xl text-primary-slate max-w-3xl mx-auto">
              Pick a region to explore licensing routes, exams, timelines, and next steps.
            </p>
          </div>
        </div>

        {/* Regions Grid */}
        <div className="py-16 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-3 gap-6">
              {regions.map((region, index) => (
                <Link
                  key={index}
                  to={region.href}
                  className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg hover:border-primary-teal transition-all group"
                >
                  <div className="flex items-start space-x-4">
                    <MapPin className="h-8 w-8 text-primary-teal flex-shrink-0 group-hover:scale-110 transition-transform" />
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-primary-navy mb-3 group-hover:text-primary-teal transition-colors">
                        {region.title}
                      </h3>
                      <p className="text-primary-slate mb-4 leading-relaxed">
                        {region.countries}
                      </p>
                      <div className="flex items-center text-primary-teal font-semibold group-hover:translate-x-1 transition-transform">
                        View Details
                        <ArrowRight className="ml-2 h-4 w-4" />
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-primary-light py-16 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-primary-navy mb-6">
              Ready to start your global nursing journey?
            </h2>
            <p className="text-xl text-primary-slate mb-8">
              Register for free and get personalized guidance for your destination.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link
                to="/signup"
                className="bg-primary-teal text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-primary-navy transition-colors inline-flex items-center"
              >
                Register Free / Sign In
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link
                to="/resources"
                className="bg-white text-primary-teal border-2 border-primary-teal px-8 py-4 rounded-lg text-lg font-semibold hover:bg-primary-light transition-colors inline-flex items-center"
              >
                Browse Resources
              </Link>
            </div>
          </div>
        </div>
      </main>
  )
}

export default Countries
